// the prod pages carry a <base id="build_version"> (see build.js)
export default !document.getElementById('build_version')
